<template>
  <div class="traceTheSource">
    <div class="traceTheSource-btnBox">
      <button class="btnBox-item start" @click="startTraceTheSource">
        开始溯源
      </button>
      <button class="btnBox-item" @click="uploaderPop(1, '选择Word文档')">
        选择Word文档
      </button>
      <button class="btnBox-item" @click="uploaderPop(2, '选择图片')">
        选择图片
      </button>
      <button class="btnBox-item" @click="uploaderPop(3, '选择视频')">
        选择视频
      </button>
      <button class="btnBox-item" @click="uploaderPop(4, '选择音频')">
        选择音频
      </button>
    </div>
    <SourceList v-if="historTrace == true"></SourceList>
    <SourceReporting
      ref="sourceReporting"
      v-else-if="sourceReporting == true"
    />
    <template v-else>
      <tinymceEditor
        :Deposit_certificate="'请输入溯源内容，溯源内容不会被收录进入数据库...'"
        :returnJoinWord="returnJoinWord"
        @handleChangeEditor="handleChangeEditor"
      />

      <editor v-show="false" ref="editor" :returnJoinWord="returnJoinWord" />
      <div v-show="false" class="traceTheSource-centerBox">
        <div class="traceTheSource-centerBox-title">
          <div class="centerBox-title-left" @click="openRename">
            {{ centerBoxTitle }}.docx
          </div>
          <div class="activeNum">字符数：{{ EditorSum }}</div>
        </div>
        <quill-editor
          ref="text"
          v-model="content"
          class="myQuillEditor"
          :options="editorOption"
          @change="EditorChange"
        />
      </div>
      <div class="traceTheSource-rightBox">
        <div class="rightBox-void" v-if="sourceReport == false">
          <div class="rightBox-void-kind" @click="previewSample">
            <span :data-fileSampleUrl="require('assets/images/sample-doc.png')">
              <img
                :src="require('assets/images/view-kind.png')"
                alt=""
              />文档报告样本
            </span>
            <span
              :data-fileSampleUrl="require('assets/images/sample-file.png')"
            >
              <img
                :src="require('assets/images/view-kind.png')"
                alt=""
              />文件报告样本
            </span>
          </div>
          <div class="rightBox-void-image"></div>
          <div class="rightBox-void-btn" @click="traceReport">溯源报告</div>
        </div>

        <div v-else>
          <div class="rightBox-btn" @click="traceReport">溯源报告</div>
          <div class="rightBox-info">
            <div class="rightBox-info-progress">
              <i
                class="rightBox-info-progress-icon"
                :class="
                  traceSourceData.level == 'A+'
                    ? 'Aadd'
                    : traceSourceData.level == 'A'
                    ? 'A'
                    : traceSourceData.level == 'B+'
                    ? 'Badd'
                    : traceSourceData.level == 'B'
                    ? 'B'
                    : 'C'
                "
              ></i>
              <div class="rightBox-info-progress-text">
                严格原创率{{ traceSourceData.dupScale }}%
              </div>
              <div class="rightBox-info-progress-percent">
                <TraceProgress :percentage="progress" />
              </div>
            </div>
            <div class="rightBox-info-textGroup">
              <div class="rightBox-info-text">
                <div class="rightBox-info-label">溯源编码：</div>
                <div class="rightBox-info-content">
                  {{ traceSourceData.soleCode }}
                </div>
              </div>
              <div class="rightBox-info-text">
                <div class="rightBox-info-label">溯源核验码：</div>
                <div class="rightBox-info-content">
                  {{ traceSourceData.reportCode }}
                </div>
              </div>
              <div class="rightBox-info-text">
                <div class="rightBox-info-label">溯源时间：</div>
                <div class="rightBox-info-content">
                  {{ traceSourceData.createTime }}
                </div>
              </div>
            </div>
            <el-collapse v-model="activeNames">
              <el-collapse-item
                v-for="(item, index) in traceSourceData.report"
                :title="item.title"
                :name="item.id"
                :key="index"
              >
                <div v-for="(child, index) in item.content" :key="index">
                  <span class="serialNum">{{ child.id }}</span>
                  <span class="contentTitle">{{ child.title }}</span>
                  <span
                    class="empower"
                    v-if="child.empower && child.empower == true"
                    @click="authorization(child)"
                    >可在线授权</span
                  >
                  <span class="empowerNo" v-else>无在线授权</span>
                  <span class="num">+{{ child.number }}</span>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>

          <transition name="el-fade-in-linear">
            <div class="rightBox-tips" v-if="dialogSwitch">
              <div class="rightBox-tips-content">
                <i class="rightBox-tips-content-icon"></i>
                <div class="rightBox-tips-content-text">
                  溯源已完成，溯源报告存放于个人“<span
                    >存证网 盘/系统文件/溯源报告</span
                  >”，官方存储系统不另行保存。
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </template>
    <!-- 提示弹窗 -->
    <el-dialog title="提示" :visible.sync="dialogTips" class="tips">
      <div class="content" v-if="curCharacter >= EditorSum">
        <div class="content-text">
          本次溯源将扣减<span>{{ EditorSum }}</span
          >个字符，字符包现有<span>{{ curCharacter }}</span
          >个字符，该字符将支付给重复字段的原创作者。
        </div>
      </div>
      <div
        class="content"
        v-else
        :class="curCharacter < EditorSum ? 'active' : ''"
      >
        <i class="content-icon"></i>
        <div class="content-text">
          本次溯源将扣减<span>{{ EditorSum }}</span
          >个字符，字符包现有<span>{{ curCharacter }}</span
          >个字符，<span>已不足。</span>
        </div>
      </div>
      <div class="footer">
        <div class="footer-btn" @click="sureSubmit">
          {{ curCharacter >= EditorSum ? '确定' : '取消' }}
        </div>
        <div
          class="footer-btn"
          v-if="curCharacter >= EditorSum"
          @click="handleQuickPay"
        >
          字符包快捷支付
        </div>
        <div
          class="footer-btn"
          v-else
          @click="
            $router.push({ name: 'CopyrightPracticeDetail', params: { id: 2 } })
          "
        >
          购买字符包
        </div>
      </div>
    </el-dialog>

    <!-- 在线授权 -->
    <el-dialog
      :modal="false"
      :close-on-click-modal="false"
      title="授权许可"
      :visible.sync="onlineAuthorization"
      class="onlineAuthorization"
    >
      <div class="content">
        <div class="content-item">
          <div class="content-label">著作权人：</div>
          <div class="content-text">{{ AuthorizationInfo.author }}</div>
        </div>
        <div class="content-item">
          <div class="content-label width">作品名称：</div>
          <div class="content-text text">{{ AuthorizationInfo.filename }}</div>
        </div>
        <div class="content-item">
          <div class="content-label">作品字数：</div>
          <div class="content-text">{{ AuthorizationInfo.wordNumber }}字符</div>
        </div>
        <div class="content-item">
          <div class="content-label">创作时间：</div>
          <div class="content-text">{{ AuthorizationInfo.publishTime }}</div>
        </div>
        <div class="content-item">
          <div class="content-label">电子数据指纹：</div>
          <div class="content-text">【 {{ AuthorizationInfo.md5 }} 】</div>
        </div>
        <div class="content-item">
          <div class="content-label">授权类型：</div>
          <div class="content-text">
            {{
              AuthorizationInfo.authorizationType
                ? AuthorizationInfo.authorizationType
                : '信息网络传播权'
            }}
          </div>
        </div>
        <div class="content-item">
          <div class="content-label">授权时限：</div>
          <div class="content-text">
            {{
              AuthorizationInfo.authorizationTerm == 1
                ? '长期'
                : `${AuthorizationInfo.startTime}到${AuthorizationInfo.endTime}`
            }}
          </div>
        </div>
        <div class="content-item">
          <div class="content-label">授权价格：</div>
          <div class="content-text">
            <span v-if="AuthorizationInfo.setPrice === 0 && fileType === 1"
              >{{ AuthorizationInfo.wordNumber }}字符</span
            >
            <span v-else>{{ AuthorizationInfo.price }}元</span>
          </div>
        </div>
        <div class="content-item">
          <div class="content-label">被授权主体：</div>
          <div class="content-text">{{ AuthorizationInfo.authorizedName }}</div>
        </div>
        <div class="content-item">
          <div class="content-label">授权使用范围：</div>
          <div class="content-text">网站、刊物、公众号、百家号等使用范围</div>
        </div>
        <div class="notes">
          注：授权成功后、授权书、作品文本将同步发送至"智能网盘/系统文件/授权文件"。
        </div>
      </div>
      <div class="footer">
        <div class="footer-btn" @click="sureAuthorization">生成授权书</div>
        <div class="footer-btn" @click="onlineAuthorization = false">取消</div>
      </div>
    </el-dialog>

    <!-- 扫码支付 -->
    <el-dialog
      :modal="false"
      @close="handleClosePaymentPopup"
      :close-on-click-modal="false"
      title="扫码支付"
      :visible.sync="paymentPopup"
      class="payment"
    >
      <div class="content">
        <div class="notes">请使用微信扫码下方二维码完成支付</div>
        <div class="imgBox">
          <img :src="qrCodedata.codeImg" alt="" />
        </div>
        <div class="price">
          应付款：<span
            >￥<span>{{ orderPrice }}</span></span
          >
        </div>
      </div>
    </el-dialog>

    <!-- 支付成功 -->
    <el-dialog
      :modal="false"
      :close-on-click-modal="false"
      title="提示"
      :visible.sync="paymentSuccessPopup"
      class="paymentSuccess"
    >
      <div class="content">
        授权书已生成！授权书、作品电子版将发送至你的“<span>智能网盘/系统文件/授权文件</span>”。
      </div>
      <div class="footer">
        <div class="footer-btn" @click="paymentSuccessPopup = false">确定</div>
        <div class="footer-btn" @click="seeAuthorize">查看授权书</div>
      </div>
    </el-dialog>

    <!--溯源可在线授权列表-->
    <el-dialog
      :modal="false"
      :close-on-click-modal="false"
      title="在线授权列表"
      :visible.sync="showAuthorizeList"
      class="authorize-list"
    >
      <div class="content">
        <ul class="file-list">
          <li
            class="file-list-item"
            v-for="(item, index) in authorizeList"
            :key="index"
          >
            <span class="file-list-item-left">
              <span class="num">+{{ item.number }}</span>
              <span class="file-name">{{ item.fileName }}</span>
            </span>
            <span class="auth" @click="showAuthorizeDetail(item.textMd5)"
              >在线授权</span
            >
          </li>
        </ul>
      </div>
    </el-dialog>

    <!--授权完成弹框提示-->
    <transition name="authorize-trans">
      <div class="authorize-tips-content" v-if="dialogGeneAuthorizeSuccessful">
        <i class="icon"></i>
        <div class="desc">
          溯源已完成，溯源报告存放于个人“<span class="blue"
            >存证网 盘/系统文件/授权</span
          >
          ”，官方存储系统不 另行保存。
        </div>
      </div>
    </transition>

    <!--溯源文件上传附件弹出框 -->
    <el-dialog
      v-dialogDrag
      :title="uploaderTitle"
      :visible.sync="uploadVisible"
      class="upload"
    >
      <!-- <div class="content-text">
        内容溯源是匹配相应的语篇、语段、语句MD5值，图片、视频与音频溯源，则是匹配相应的哈希值，在我们数据库中有无对应的值。
      </div> -->
      <!--上传器-->
      <UploadBigFile
        ref="uploader"
        class="uploadSlot"
        :parentId="parentId"
        :columnType="columnType"
        :fileType="fileType"
        @onFileSuccess="onFileSuccess"
        @onFileError="onFileError"
      >
      </UploadBigFile>
    </el-dialog>

    <!-- 字符支付弹窗 -->
    <el-dialog title="提示" :visible.sync="characterPayDialog" class="tips">
      <div class="content" v-if="curCharacter >= characterSum">
        <div class="content-text">
          本次在线授权将扣减<span>{{ characterSum }}</span
          >个字符，字符包现有<span>{{ curCharacter }}</span
          >个字符。
        </div>
      </div>
      <div
        class="content"
        v-else
        :class="curCharacter < characterSum ? 'active' : ''"
      >
        <i class="content-icon"></i>
        <div class="content-text">
          本次在线授权将扣减<span>{{ characterSum }}</span
          >个字符，字符包现有<span>{{ curCharacter }}</span
          >个字符，<span>已不足。</span>
        </div>
      </div>
      <div class="footer">
        <div class="footer-btn" @click="payauthorizationCharacterPay">
          {{ curCharacter >= characterSum ? '确定' : '取消' }}
        </div>
        <div
          class="footer-btn"
          v-if="curCharacter >= characterSum"
          @click="handleQuickPay"
        >
          字符包快捷支付
        </div>
        <div
          class="footer-btn"
          v-else
          @click="
            $router.push({ name: 'CopyrightPracticeDetail', params: { id: 2 } })
          "
        >
          购买字符包
        </div>
      </div>
    </el-dialog>

    <!-- 重命名 -->
    <el-dialog
      title="重命名"
      :visible.sync="rename"
      class="rename"
      :modal="false"
      top="0"
      :before-close="handleCloseRename"
    >
      <div class="content">
        <div class="content-label">文件名</div>
        <input type="text" v-model="fileNameInput" class="content-input" />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="footer-btn sure" @click="sureRename">确定</div>
        <div class="footer-btn" @click="handleCloseRename">取消</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import editor from 'components/editor/editor.vue'
import tinymceEditor from 'components/editor/tinymceEditor.vue'

import { quillEditor } from 'vue-quill-editor'
import SourceList from 'components/HistoricalTracing'
import SourceReporting from 'components/TraceTheSourceReporting'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import UploadBigFile from 'components/disk/TraceTheSourceUpload.vue'
import TraceProgress from 'components/TraceProgress'
import { preserveWord } from 'api/common'
import {
  checkInterestsNumber,
  traceSource,
  deductInterestsNumber,
  getWorkDetails,
  generateAuthorization,
  getTraceSourceResult,
  findTraceAuthorizationList,
  payOtherOrderPay,
  payAuthorizationCharacterPay,
  PaywechatOtherOrderQueryQrcode,
  delTracesourceQueue,
  getTraceSetup,
  postTraceSetup,
} from 'api/traceTheSource'
export default {
  data() {
    return {
      content: '', //带标签的富文本字符
      changeText: [], //记录富文本字符改变
      editorOption: {
        //  placeholder: "请输入溯源内容，溯源内容不会被收录进入数据库",
        modules: {
          toolbar: {
            container: [
              //自定义工具栏选项
              //工具栏设置
              ['revoke', 'redo', 'preserve'], //添加的按钮
              [{ font: [] }], //字体
              [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
              ['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线

              //  [{ 'header': 1 }, { 'header': 2 }],        // 标题，键值对的形式；1、2表示字体大小
              [{ color: [] }], // 字体颜色，字体背景颜色
              [{ align: [] }], //对齐方式
              [{ script: 'sub' }, { script: 'super' }], // 上下标
              ['clean'], //清除字体样式
              //[{ 'indent': '-1'}, { 'indent': '+1' }],     // 缩进
              //  [{ 'direction': 'rtl' }],             // 文本方向
              // [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
            ],
            handlers: {
              //给自定义按钮添加的事件
              revoke: () => {
                //撤销
                this.$refs.text.quill.history.undo()
              },
              redo: () => {
                //恢复
                this.$refs.text.quill.history.redo()
              },
              preserve: async () => {
                if (!this.content) {
                  return this.$message({
                    type: 'error',
                    message: '内容不能为空!',
                  })
                }
                this.$store.commit('playLifeLoading', true)
                let form = new FormData()
                form.append('fileName', this.centerBoxTitle + '.docx')
                form.append('content', this.content)
                const res = await preserveWord(form)
                if (res) {
                  const blob = new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  })
                  let objectUrl = URL.createObjectURL(blob)
                  let link = document.createElement('a')
                  link.style.display = 'none'
                  link.href = objectUrl
                  link.setAttribute('download', this.centerBoxTitle + '.docx')
                  document.body.appendChild(link)
                  link.click()
                  window.URL.revokeObjectURL(link.href)
                  document.body.removeChild(link)
                }
                this.$store.commit('playLifeLoading', false)
              },
            },
          },
        },
      },
      initButton: function () {
        //在使用的页面中初始化按钮样式
        let revoke = document.querySelector('.ql-revoke') //获取元素
        let redo = document.querySelector('.ql-redo')
        let preserve = document.querySelector('.ql-preserve')
        let Front = document.createElement('i') //创建元素
        let after = document.createElement('i')
        let preserveIcon = document.createElement('i')
        Front.className = 'revoke' //新增class属性
        after.className = 'redo'
        preserveIcon.className = 'preserve'
        revoke.appendChild(Front) //追加到元素中
        redo.appendChild(after)
        preserve.appendChild(preserveIcon)
      },
      centerBoxTitle: '未命名', //富文本的标题名字
      font: '', //不带标签的富文本字符
      dialogTips: false, //提示弹窗
      activeNames: [1, 2, 3],
      historTrace: false, //控制显示历史溯源开关
      dialogSwitch: false, //溯源成功提示
      curCharacter: null, //字符总数
      sourceReport: false, //历史溯源报告
      sourceReporting: false, //文件进行溯源报告
      onlineAuthorization: false, //在线授权弹窗
      paymentPopup: false, //支付弹窗
      paymentSuccessPopup: false, //支付成功弹窗
      traceSourceData: '', //溯源结果数据
      traceReportList: [], //历史溯源报告数据
      traceReportTotal: 0, //历史溯源报告条数
      AuthorizationInfo: '', //授权许可数据
      source_timer: null, //溯源计时器id
      progress: 0, //溯源进度
      columnType: 4, //上传类型：溯源 - 4
      fileType: 1, //文件类型
      uploaderTitle: '选择Word文档', //上传文件类型标题
      uploadVisible: false, //显示上传文件弹窗
      parentId: 0, //网盘parentId-required
      userId: this.$store.state.user_info && this.$store.state.user_info.id, //用户id
      //显示可在线授权列表
      showAuthorizeList: false,
      //可在线授权列表数据
      authorizeList: [],
      //是否正在生产授权
      isGeneAuthorize: false,
      //显示授权生产成功弹窗
      dialogGeneAuthorizeSuccessful: false,
      // 字符支付弹窗
      characterPayDialog: false,
      // 支付字符数量
      characterSum: '',
      //定时器
      timer: null,
      // 支付 oid
      oid: '',
      // 支付二维码
      qrCodedata: {},
      // 支付价格
      orderPrice: '',
      //当前上传文件列表成功或失败计数
      fileList: [],
      // 重命名弹窗
      rename: false,
      // 重命名输入框数据
      fileNameInput: '',
      condition: true, //Update 方法
      // editor 溯源之后的数据
      returnJoinWord: '',
      // 字符数量
      EditorSum: 0,
      //
      Editorhtml: '',
      //溯源设置  type: 1-快捷支付 2-手动扣减  style: 1-红色字体 2-蓝色字体 3-下划线  source: 1-脚注 2-尾注
      traceSetup: {},
      closeTimer: null,
    }
  },
  components: {
    quillEditor,
    SourceList,
    SourceReporting,
    UploadBigFile,
    editor,
    tinymceEditor,
    TraceProgress,
  },
  watch: {
    content: {
      handler: function (cur) {
        if (cur && cur != '') {
          this.font = cur.replace(/<[^>]+>/g, '')
        } else {
          this.font = ''
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.initButton() //调用方法
  },
  methods: {
    //获取溯源设置
    async getTraceSettings() {
      const res = await getTraceSetup()
      if (res.code == 200) {
        const {
          id,
          payType: type,
          fieldStyle: style,
          sourceLocation: source,
        } = res.data
        this.traceSetup = {
          type,
          style,
          source,
          id,
        }
      }
    },
    //设置快捷支付
    async setQuickPay() {
      const data = {
        id: this.traceSetup.id,
        payType: 1,
        fieldStyle: this.traceSetup.style,
        sourceLocation: this.traceSetup.source,
      }
      const res = await postTraceSetup(data)
      if (res.code != 200) {
        this.$message({
          type: 'error',
          message: res.message,
          duration: 1000,
        })
      }
      await this.getTraceSettings()
    },
    //字符快捷支付
    async handleQuickPay() {
      await this.setQuickPay()
      this.getFontNumber()
    },
    handleChangeEditor(val) {
      this.Editorhtml = val[0]
      this.font = val[0]
      this.EditorSum = val[1]
      this.centerBoxTitle = val[2]
    },
    //确定重命名
    sureRename() {
      if (/ /.test(this.fileNameInput)) {
        return this.$message({
          type: 'error',
          message: '不能有空格字符',
        })
      }
      this.centerBoxTitle = this.fileNameInput
      this.rename = false
    },
    //预览样本
    previewSample(e) {
      const target = e.target || e.srcElement
      if (target.dataset.filesampleurl) {
        window.open(target.dataset.filesampleurl)
      }
    },
    //点击选择文件按钮
    uploaderPop(type, title) {
      this.$store.commit('CHECK_USER_OPTIONS', {
        //忽略实名验证
        ignoreReal: true,
        //验证通过后回调
        afterCheck: () => {
          if (
            this.sourceReporting &&
            this.$refs['sourceReporting'].isReporting
          ) {
            this.$refs['sourceReporting'].showTips2 = true
            this.$refs['sourceReporting'].tips_text =
              '还有文件正在上传,请稍后...'
          } else {
            this.uploadVisible = true
            this.uploaderTitle = title
            this.fileType = type
            //完成后清空文件列表
            this.$bus.$emit('clearFileList')
            this.fileList = []
            //清空溯源文件队列
            delTracesourceQueue()
          }
        },
      })
    },
    // 打开重命名
    openRename() {
      this.rename = true
      this.fileNameInput = this.centerBoxTitle
    },
    //  重命名弹窗关闭触发
    handleCloseRename() {
      this.rename = false
      this.fileNameInput = ''
    },
    // 富文本监听事件
    EditorChange() {
      if (this.changeText.length >= 50) {
        //限制数组长度
        this.changeText.shift() //清除第一条数据
        this.changeText.push(this.content)
      } else {
        this.changeText.push(this.content) //追加数据
      }
    },
    //文件上传成功
    /**
     * 每一个文件上传成功后触发该事件
     *
     */
    onFileSuccess(file) {
      if (!file.isFolder) {
        //文件上传完成后往fileList数组加一位计数，当长度与uploader内文件队列数量相等时
        //再开始溯源操作，防止刷新前面的文件
        this.fileList.push(1)
        if (this.fileList.length == file.uploader.files.length) {
          this.historTrace = false
          this.sourceReporting = true
          this.uploadVisible = false
          setTimeout(async () => {
            await this.$refs['sourceReporting'].findTraceReportQueue()
            this.$refs['sourceReporting'].checkTotalCharacter()
          }, 1000)
        }
      }
    },
    //文件上传失败
    onFileError(file) {
      if (!file.isFolder) {
        //文件上传失败时也计数
        this.fileList.push(1)
        if (this.fileList.length == file.uploader.files.length) {
          this.historTrace = false
          this.sourceReporting = true
          this.uploadVisible = false
          setTimeout(async () => {
            await this.$refs['sourceReporting'].findTraceReportQueue()
            this.$refs['sourceReporting'].checkTotalCharacter()
          }, 1000)
        }
      }
      this.fileList = []
      this.$bus.$emit('clearFileList')
    },
    // 打开溯源报告
    traceReport() {
      this.$store.commit('CHECK_USER_OPTIONS', {
        ignoreReal: true,
        afterCheck: () => {
          this.historTrace = true
        },
      })
    },
    // 开始溯源按钮
    startTraceTheSource() {
      this.$store.commit('CHECK_USER_OPTIONS', {
        ignoreReal: true,
        afterCheck: () => {
          if (this.sourceReporting) {
            if (this.$refs['sourceReporting'].isReporting) {
              return this.$message({
                type: 'success',
                message: '当前批量溯源正在进行中',
              })
            }
            return
          }
          if (!(this.historTrace || this.sourceReporting)) {
            this.font
            this.content
            this.EditorSum
            this.centerBoxTitle
          }
          if (this.historTrace == true) {
            this.historTrace = false
            this.sourceReport = false
            this.content = ''
            return
          }
          if (this.font == '') {
            this.$message({
              type: 'error',
              message: '内容不能为空！',
            })
            return
          }
          if (this.EditorSum <= 4) {
            this.$message({
              type: 'error',
              message: '字符长度不能小于4',
            })
            return
          }
          this.progress = 0
          this.getFontNumber()
        },
      })
    },
    // 获取字符数量
    async getFontNumber(sum) {
      const data = {
        deductNum: sum ? sum : this.EditorSum,
        type: 2,
      }
      const res = await checkInterestsNumber(data)
      if (res.code === 200 || res.code === 7002) {
        this.curCharacter = res.data
        if (this.traceSetup.type == 1) {
          if (!sum) {
            if (this.curCharacter < this.EditorSum) {
              this.dialogTips = true
            } else {
              this.sureTraceSource()
            }
          } else {
            if (this.curCharacter < sum) {
              this.characterPayDialog = true
            } else {
              this.payauthorizationCharacterPay()
            }
          }
        } else {
          if (!sum) {
            this.dialogTips = true
          } else {
            this.characterPayDialog = true
          }
        }
      } else {
        this.$message({
          type: 'error',
          message: res.message,
        })
      }
    },
    // 扣减字符
    async deductInterests() {
      const data = {
        deductNum: this.EditorSum,
        type: 2,
      }
      const res = await deductInterestsNumber(data)
      if (res.code === 200) {
        this.sureTraceSource()
      } else {
        this.$message({
          type: 'error',
          message: res.message,
        })
      }
    },
    // 确定溯源
    sureSubmit() {
      if (this.curCharacter < this.EditorSum) {
        this.dialogTips = false
        return
      }
      this.dialogTips = false
      // this.deductInterests();
      this.sureTraceSource()
    },
    // 发送溯源内容
    async sureTraceSource() {
      this.dialogTips = false
      this.sourceReport = true
      this.progress = 0
      this.$message({
        type: 'success',
        message: '开始溯源',
      })
      const data = {
        platform: 1,
        wordContent: this.Editorhtml,
        userId: this.userId,
        traceModel: 1,
        fileName: this.centerBoxTitle,
      }
      let resultId
      const res = await traceSource(data)
      if (res.code == 200) {
        resultId = res.data
      }
      setTimeout(() => {
        this.getTraceSourceResult(resultId)
      }, 2000)
    },
    //获取溯源结果
    getTraceSourceResult(id) {
      let renderingData = (res) => {
        if (res.data.reportHtml) this.content = res.data.reportHtml
        this.traceSourceData = res.data
        this.progress = this.traceSourceData.progress
          ? this.traceSourceData.progress > 100
            ? 100
            : +this.traceSourceData.progress
          : 0
        this.traceSourceData.report &&
          this.traceSourceData.report.map((item) => {
            if (item.id == 1) {
              item.title = `一、${item.title} ${item.repeatRate}%`
            } else if (item.id == 2) {
              item.title = `二、${item.title} ${item.repeatRate}%`
            } else {
              item.title = `三、${item.title} ${item.repeatRate}%`
            }
          })
      }
      //获取溯源结果
      // this.source_timer = setInterval(() => {}, 2000);
      const params = { id }
      getTraceSourceResult(params)
        .then((res) => {
          if (res.code == 200) {
            this.returnJoinWord = this.returnJoinWord + ' '
            setTimeout(() => {
              if (res.data.reportHtml) this.returnJoinWord = res.data.reportHtml
            })
            renderingData(res)
            setTimeout(() => {
              this.dialogSwitch = true
              setTimeout(() => {
                this.dialogSwitch = false
              }, 2000)
            }, 500)
          } else if (res.code == 8001) {
            setTimeout(() => {
              this.getTraceSourceResult(id)
            }, 2000)
          } else {
            this.$message({
              type: 'error',
              message: res.message,
            })
          }
        })
        .catch((e) => {
          this.$message({
            type: 'error',
            message: e.name + e.message,
          })
        })
    },
    // 在线授权
    async authorization(item) {
      // const md5 = "asd1231sq"
      const md5 = item.textMd5
      const res = await getWorkDetails(md5)
      if (res.code === 200) {
        this.AuthorizationInfo = res.data
        this.onlineAuthorization = true
      } else {
        this.$message({
          type: 'error',
          message: res.message,
        })
      }
    },
    // 生成授权书
    async sureAuthorization() {
      if (this.isGeneAuthorize) {
        return this.$message({
          type: 'warning',
          message: '您操作太快了,请稍后再试~',
        })
      }
      this.isGeneAuthorize = true
      const data = {
        md5: this.AuthorizationInfo.md5,
        range: '网站、刊物、公众号、百家号等使用范围',
        platform: 1,
      }
      try {
        const res = await generateAuthorization(data)
        // console.log(res);
        if (res.code === 200) {
          // console.log(res);
          if (res.data.priceType === 1) {
            this.oid = res.data.otherOrderId
            this.orderPrice = res.data.orderPrice
            this.payotherOrderPay(res.data.otherOrderId)
          } else {
            this.oid = res.data.otherOrderId
            this.characterSum = res.data.orderPrice
            this.getFontNumber(this.characterSum)
          }

          this.onlineAuthorization = false
        } else {
          this.$message({
            type: 'error',
            message: res.message,
          })
        }
        this.isGeneAuthorize = false
      } catch (e) {
        console.log(e)
        this.isGeneAuthorize = false
      }
    },

    /***
     * 查找溯源可在线授权列表
     * @param { Number } id 当前文件id
     */
    async findAuthorizeList(id) {
      const params = { reportId: id }
      const res = await findTraceAuthorizationList(params)
      if (res.code == 200) {
        this.authorizeList = res.data
      }
    },
    /***
     * 显示授权许可
     * @param { String } textMd5 文件md5值
     */
    showAuthorizeDetail(textMd5) {
      this.authorization({ textMd5 })
    },

    // 授权生成支付二维码
    async payotherOrderPay(id) {
      let that = this
      const data = {
        oid: id,
      }

      const res = await payOtherOrderPay(data)

      if (res.code === 200) {
        if (this.closeTimer) {
          clearTimeout(this.closeTimer)
          this.closeTimer = null
        }
        this.paymentPopup = true
        this.qrCodedata = res.data
        this.closeTimer = setTimeout(() => {
          clearInterval(this.timer)
          this.paymentPopup = false
        }, 180000)
        this.timer = window.setInterval(function () {
          that.paywechatOtherOrderQueryQrcode()
        }, 3000)
      } else {
        this.$message({
          type: 'error',
          message: res.message,
        })
      }
    },

    // 字符支付
    async payauthorizationCharacterPay() {
      if (this.curCharacter < this.characterSum) {
        this.characterPayDialog = false
        return
      }
      const data = {
        oid: this.oid,
      }
      this.characterPayDialog = false
      this.$store.commit('playLifeLoading', true)
      const res = await payAuthorizationCharacterPay(data)
      if (res.code === 200) {
        setTimeout(() => {
          this.dialogGeneAuthorizeSuccessful = true
          setTimeout(() => {
            this.dialogGeneAuthorizeSuccessful = false
          }, 2000)
        }, 500)
      } else {
        this.$message({
          type: 'error',
          message: res.message,
        })
      }
      this.$store.commit('playLifeLoading', false)
    },

    // 查询微信二维码扫码状态
    async paywechatOtherOrderQueryQrcode() {
      const data = {
        oid: this.oid,
      }

      const res = await PaywechatOtherOrderQueryQrcode(data)
      if (res.code == 200) {
        window.clearInterval(this.timer)
        this.paymentPopup = false
        this.paymentSuccessPopup = true
        setTimeout(() => {
          this.dialogGeneAuthorizeSuccessful = true
          setTimeout(() => {
            this.dialogGeneAuthorizeSuccessful = false
          }, 2000)
        }, 500)
      }
    },
    //查看授权书
    seeAuthorize() {
      this.$store.commit('ChangeSideBarId', '55')
      this.$router.push({
        path: '/disk',
      })
    },
    // 关闭支付弹窗停止定时器
    handleClosePaymentPopup() {
      // console.log(1);
      window.clearInterval(this.timer)
    },
  },
  updated() {
    if (!this.condition) {
      this.initButton()
      this.condition = true
    }
  },
  created() {
    // this.getTraceSettings();
    // this.content =
    //   this.font = `<p class=\"ql-align-center\">\t<strong>陈绍旺简历</strong></p><p class=\"ql-align-center\"><strong>&nbsp;</strong></p><p class=\"ql-align-center\"><strong>&nbsp;</strong></p><p>\t<span style=\"color: rgb(51, 51, 51);\">陈绍旺：男，汉族，1971年2月生，中共党员，研究生学历，经济学博士，现任中共大连市委副书记，市长、市政府党组书记。</span></p><p>\t<span style=\"color: rgb(51, 51, 51);\">历任：天津港保税区第三招商办公室主任，天津港保税区经济发展局副局长、局长，天津港保税区管委会副主任，天津天保控股有限公司党委副书记、总经理，中天航空工业投资股份有限公司董事长，天津市西青区委副书记、区长，天津市和平区委书记，2020年3月任中共大连市委副书记，市政府党组书记、副市长、代市长，2020年5月任中共大连市委副书记，市长、市政府党组书记。</span></p><p>\t<span style=\"color: rgb(51, 51, 51);\">座谈会上，民革中央主席万鄂湘、民盟中央主席丁仲礼、民建中央主席郝明金、民进中央主席蔡达峰、农工党中央主席陈竺、致公党中央常务副主席蒋作君、九三学社中央主席武维华、台盟中央主席苏辉、全国工商联主席高云龙、无党派人士代表宇如聪先后发言。他们完全赞同中共中央对当前我国经济形势的分析判断和明年经济工作的谋划考虑，并就加强宏观调控、提升政策效能，改善进出口结构、促进内外贸一体化，提高生产制造装备水平、加快我国高端制造业发展，健全人口服务体系、激发内需增长潜力，完善我国疫情防控策略、为稳增长打牢扎实基础，强化法治保障和政策引领、科学有序推进“双碳”目标，转变涉企财税支持方式、提高财政收入质量，加强农村生态环境治理、夯实乡村振兴基础，加大改革力度、助力推进共同富裕，强化中小企业发展政策导向和可持续发展能力，发挥民企在促进共同富裕中积极作用，完善科技领域“揭榜挂帅”工作机制，加快推动省际交界地区协同发展等提出意见建议。</span></p><p>\t<span style=\"color: rgb(51, 51, 51);\">要坚持稳中求进工作总基调，完整、准确、全面贯彻新发展理念，加快构建新发展格局，全面深化改革开放，推动高质量发展，统筹疫情防控和经济社会发展，统筹发展和安全，持续改善民生，保持社会大局稳定，迎接中共二十大胜利召开。</span></p><p>\t<span style=\"color: rgb(51, 51, 51);\">我：我们在广东工业大学每年都会承接计算机等级考试，还有像广东财经大学每年也会有ATA的考试，都运行的十分稳定呢，您有时间的话我们可以带您去现场参观考察，指导下我们的工作</span></p><p>\t<span style=\"color: rgb(51, 51, 51);\">我：那太好了，我是武汉噢易云计算广州分公司的销售小王，我们主要做实验室相关类软件，我想跟您了解下咱们语音机房的一些基本情况，您现在方便吗？</span></p><p>\t<span style=\"color: rgb(51, 51, 51);\">李老师：既能上语音课又能上计算机课吗？你们是怎么实现的？</span></p><p>\t<span style=\"color: rgb(51, 51, 51);\">我：经管类这样的机房我们已经做过很多了，像矿业大学江苏大学有的已经运行超过3年的时间，您方便的话我也可以安排我们当地办事处的同事带您去参观交流看看。</span></p><p><br></p>`;
    this.$bus.$on('showAuthorizeList', (id) => {
      this.showAuthorizeList = true
      this.findAuthorizeList(id)
    })
    this.$bus.$on('traceSetup', () => {
      this.getTraceSettings()
    })
  },
  destroyed() {
    this.$bus.$off('showAuthorizeList')
  },
  beforeDestroy() {
    //页面销毁前，清除定时器
    window.clearInterval(this.timer) //清除timer1定时器
  },
}
</script>

<style>
/* 富文本汉化 */
p {
  margin: 10px;
}
.ql-formats {
  margin-right: 0px !important;
}
.edit_container,
.quill-editor {
  height: 300px;
}
.ql-snow .ql-picker.ql-font {
  width: 83px !important;
}
.ql-snow .ql-picker.ql-size {
  width: 87px !important;
}
.revoke {
  display: inline-block;
  width: 15px;
  height: 14px;
  background-image: url('../../assets/images/undo.png');
  background-size: cover;
  background-repeat: no-repeat;
}
.redo {
  display: inline-block;
  width: 15px;
  height: 14px;
  background-image: url('../../assets/images/redo.png');
  background-size: cover;
  background-repeat: no-repeat;
}
.preserve {
  display: inline-block;
  width: 15px;
  height: 15px;
  background-image: url('../../assets/images/preserve.png');
  background-size: cover;
  background-repeat: no-repeat;
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
  content: '10px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
  content: '18px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
  content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: '文本';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='1']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='1']::before {
  content: '标题1';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='2']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='2']::before {
  content: '标题2';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='3']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='3']::before {
  content: '标题3';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='4']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='4']::before {
  content: '标题4';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='5']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='5']::before {
  content: '标题5';
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value='6']::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value='6']::before {
  content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: '标准字体';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='serif']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='serif']::before {
  content: '衬线字体';
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
  content: '等宽字体';
}
</style>

<style lang="scss" scoped>
.traceTheSource {
  height: 931px;
  border: 1px solid #eceff1;
  border-radius: 5px;
  display: flex;
  &-btnBox {
    width: 149px;
    border-right: 1px solid #eceff1;
    text-align: center;
    background-color: #fff;
    .btnBox-item {
      width: 100px;
      height: 37px;
      border: 1px solid $color-bg-heightlight;
      border-radius: 3px;
      font-size: $font-size-small;
      font-family: PingFang SC;
      font-weight: 400;
      color: $color-text-black;
      background: none;
      margin-top: 30px;
      cursor: pointer;
    }
    .start {
      color: $color-text-white;
      background: $color-bg-heightlight;
    }
  }
  &-centerBox {
    flex: 1;
    width: 773px;
    position: relative;
    &-title {
      display: flex;
      height: 30px;
      background: #f7f7f7;
      align-items: center;
      justify-content: space-between;
      .centerBox-title-left {
        min-width: 170px;
        max-width: 200px;
        height: 30px;
        background: #ffffff;
        text-indent: 2em;
        line-height: 30px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        cursor: pointer;
      }
      .activeNum {
        font-size: $font-size-medium;
        font-family: PingFang SC;
        font-weight: 500;
        color: $color-text-gray;
        margin-right: 13px;
      }
    }
    ::v-deep .myQuillEditor {
      .ql-toolbar {
        border: none;
      }
      .ql-container.ql-snow {
        border: none;
        height: 857px;
      }
    }
  }
  &-rightBox {
    width: 524px;
    border-left: 1px solid #eceff1;
    position: relative;
    background-color: #fff;
    .rightBox-void {
      // width: 211px;
      // margin: 39px auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .rightBox-void-kind {
        @include flex-start;
        align-self: flex-end;
        margin-top: 17px;
        margin-right: 17px;
        > span {
          font-size: 14px;
          font-weight: 500;
          color: #ff6900;
          cursor: pointer;
          img {
            width: 14px;
            height: 14px;
            margin-right: 5px;
            vertical-align: middle;
          }
          &:first-child ~ span {
            margin-left: 29px;
          }
        }
      }
      .rightBox-void-image {
        width: 211px;
        height: 204px;
        margin-top: 8px;
        @include backgroundGroup('../../assets/images/rightIcon.png');
      }
      .rightBox-void-btn {
        margin-top: 50px;
        width: 101px;
        height: 37px;
        border: 1px solid $color-bg-heightlight;
        border-radius: 3px;
        font-size: $font-size-small;
        font-family: PingFang SC;
        font-weight: 500;
        color: $color-bg-heightlight;
        text-align: center;
        cursor: pointer;
        line-height: 37px;
      }
    }
    .rightBox-btn {
      margin: 22px auto 0;
      width: 101px;
      height: 37px;
      border: 1px solid $color-bg-heightlight;
      border-radius: 3px;
      line-height: 37px;
      text-align: center;
      font-size: $font-size-small;
      font-family: PingFang SC;
      font-weight: 500;
      color: $color-bg-heightlight;
      cursor: pointer;
    }
    .rightBox-info {
      margin-left: 40px;
      margin-top: 30px;
      position: relative;
      .rightBox-info-progress {
        @include flex-start;
        .rightBox-info-progress-icon {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
        .Aadd {
          @include backgroundGroup('../../assets/images/A+.png');
        }
        .A {
          @include backgroundGroup('../../assets/images/A.png');
        }
        .Badd {
          @include backgroundGroup('../../assets/images/B+.png');
        }
        .B {
          @include backgroundGroup('../../assets/images/B.png');
        }
        .C {
          @include backgroundGroup('../../assets/images/c.png');
        }
        .rightBox-info-progress-text {
          font-size: $font-size-medium;
          font-family: PingFang SC;
          font-weight: 500;
          color: $color-bg-heightlight;
          margin-right: 20px;
        }
        .rightBox-info-progress-percent {
          @include flex-start;
          width: 204px;
        }
      }
      .rightBox-info-textGroup {
        margin-top: 20px;
        .rightBox-info-text {
          display: flex;
          margin-top: 10px;
          .rightBox-info-label {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: $color-text-gray;
          }
          .rightBox-info-content {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: $color-text-black;
          }
        }
      }
      ::v-deep .el-collapse {
        border: none;
        .el-collapse-item__arrow {
          margin: 0 8px 0;
        }
        .el-collapse-item__header {
          border-bottom: none;
          font-size: $font-size-medium;
          font-family: PingFang SC;
          font-weight: bold;
          color: $color-text-black;
        }
        .el-collapse-item__wrap {
          border-bottom: none;
        }
        .el-collapse-item__content {
          height: auto;
          max-height: 375px;
          overflow-y: scroll;
          padding-bottom: 0;
          > div {
            font-size: $font-size-medium;
            font-family: PingFang SC;
            font-weight: 500;
            color: $color-text-gray;
            display: flex;
            align-items: center;
            .serialNum {
              display: inline-block;
              width: 20px;
            }
            .contentTitle {
              display: inline-block;
              @include ellipsis();
              width: 320px;
            }
            .empowerNo {
              color: $color-text-gray;
              text-decoration: underline;
            }
            .empower {
              color: $color-bg-heightlight;
              text-decoration: underline;
              cursor: pointer;
            }
            .num {
              display: inline-block;
              margin-left: 5px;
              color: #eb441e;
            }
          }
        }
      }
    }
    .rightBox-tips {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 391px;
      height: 103px;
      background: #ffffff;
      border: 1px solid #ff6900;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      &-content {
        display: flex;
        margin: 0 20px;
        .rightBox-tips-content-icon {
          width: 42px;
          height: 21px;
          margin-right: 10px;
          @include backgroundGroup('../../assets/images/PromptSuccessful.png');
          transform: translateY(4px);
        }
        .rightBox-tips-content-text {
          font-size: $font-size-medium-x;
          font-family: PingFang SC;
          font-weight: 500;
          color: $color-text-black;
          line-height: 26px;
          span {
            color: $color-bg-heightlight;
          }
        }
      }
    }
  }
  .tips {
    ::v-deep .el-dialog {
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
      width: 340px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
      .el-dialog__header {
        padding: 12px 12px 0px;
        .el-dialog__title {
          font-size: $font-size-small;
          font-family: PingFang SC;
          font-weight: 400;
          color: $color-text-gray;
        }
        .el-dialog__headerbtn {
          top: 12px;
          right: 12px;
        }
      }
      .el-dialog__body {
        padding: 15px 39px;
        .content {
          font-size: $font-size-medium-x;
          font-family: PingFang SC;
          font-weight: 500;
          color: $color-text-black;
          line-height: 26px;
          display: flex;
          span {
            color: #eb441e;
          }
          .content-icon {
            width: 31px;
            height: 18px;
            @include backgroundGroup('../../assets/images/del-error.png');
            transform: translateY(4px);
            margin-right: 9px;
          }
        }
        .active {
          margin-top: 20px;
        }
        .footer {
          display: flex;
          justify-content: space-between;
          margin-top: 28px;
          .footer-btn {
            font-size: $font-size-medium;
            font-family: PingFang SC;
            font-weight: 500;
            color: $color-bg-heightlight;
            cursor: pointer;
          }
        }
      }
    }
  }
  .onlineAuthorization {
    ::v-deep .el-dialog {
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
      width: 497px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
      .el-dialog__header {
        padding: 20px 0 0;
        text-align: center;
        font-size: $font-size-medium;
        font-family: PingFang SC;
        font-weight: 500;
        color: $color-text-black;
        .el-dialog__headerbtn {
          top: 10px;
          right: 10px;
          font-size: 20px;
        }
      }
      .el-dialog__body {
        padding: 20px 30px 30px 20px;
        .content {
          line-height: 24px;
          .content-item {
            display: flex;
            font-size: $font-size-medium;
            font-family: PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 24px;

            .width {
              width: 70px;
            }

            .text {
              flex: 1;
            }
          }
          .notes {
            font-size: $font-size-small;
            font-family: PingFang SC;
            font-weight: 400;
            color: $color-text-gray-s;
          }
        }
        .footer {
          display: flex;
          padding: 30px 120px 0;
          justify-content: space-between;
          .footer-btn {
            cursor: pointer;
            font-size: $font-size-medium;
            font-family: PingFang SC;
            font-weight: 500;
            color: $color-bg-heightlight;
          }
        }
      }
    }
  }
  // 支付弹窗
  .payment {
    ::v-deep .el-dialog {
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
      width: 500px;
      height: 390px;
      background: #ffffff;
      border: 0px solid #818790;
      box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
      .el-dialog__header {
        height: 42px;
        background: #f4f6f7;
        padding: 0;
        line-height: 42px;
        .el-dialog__title {
          margin-left: 15px;
          font-size: $font-size-medium;
          font-family: PingFang SC;
          font-weight: 500;
          color: #393939;
        }
        .el-dialog__headerbtn {
          top: $font-size-small;
          right: $font-size-small;
          font-size: $font-size-large;
        }
      }
      .el-dialog__body {
        padding: 65px 20px;
        .content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .notes {
            font-size: $font-size-medium;
            font-family: PingFang SC;
            font-weight: 500;
            color: $color-text-black;
          }
          .imgBox {
            width: 110px;
            height: 110px;
            margin-top: 30px;
            img {
              width: 110px;
              height: 110px;
            }
          }
          .price {
            margin-top: 30px;
            font-size: $font-size-medium;
            font-family: PingFang SC;
            font-weight: 500;
            color: #393939;
            span {
              color: #eb441e;
              span {
                font-size: $font-size-large;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
  }
  // 支付成功弹窗
  .paymentSuccess {
    ::v-deep .el-dialog {
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
      width: 340px;
      height: 200px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
      .el-dialog__header {
        padding: 12px 12px 0px;
        .el-dialog__title {
          font-size: $font-size-small;
          font-family: PingFang SC;
          font-weight: 400;
          color: $color-text-gray;
        }
        .el-dialog__headerbtn {
          top: 12px;
          right: 12px;
        }
      }
      .el-dialog__body {
        padding: 15px 39px;
        .content {
          font-size: $font-size-medium-x;
          font-family: PingFang SC;
          font-weight: 500;
          color: $color-text-black;
          line-height: 26px;
          span {
            color: $color-bg-heightlight;
          }
        }
        .footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 25px;
          .footer-btn {
            font-size: $font-size-medium;
            font-family: PingFang SC;
            font-weight: 500;
            color: $color-bg-heightlight;
            cursor: pointer;
          }
        }
      }
    }
  }
  //可在线授权列表
  .authorize-list {
    ::v-deep .el-dialog {
      @include flex-center(column);
      justify-content: normal;
      align-items: normal;
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0 !important;
      width: 497px;
      height: 421px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
      .el-dialog__header {
        padding: 14px 9px 13px;
        background: #f4f6f7;
        .el-dialog__title {
          font-size: 14px;
          font-weight: 500;
          color: #333;
        }
        .el-dialog__headerbtn {
          top: 18px;
          right: 12px;
        }
      }
      .el-dialog__body {
        @include flex-center(column);
        justify-content: normal;
        align-items: normal;
        flex: 1;
        padding: 30px 5px 30px 30px;
        .content {
          height: 310px;
          .file-list {
            height: 100%;
            padding-right: 30px;
            overflow-y: scroll;
            &::-webkit-scrollbar-track {
              box-shadow: none;
              background-color: #fff;
            }
            &-item {
              @include flex-between;
              font-size: 14px;
              font-weight: 500;
              color: #333333;
              &-left {
                @include flex-start;
              }
              .num {
                @include ellipsis;
                max-width: 80px;
                color: #f95656;
              }
              .file-name {
                @include ellipsis;
                width: 260px;
                margin-left: 10px;
              }
              .auth {
                margin-left: 10px;
                margin-right: 10px;
                color: #ff6900;
                text-decoration: underline;
                cursor: pointer;
              }
              &:first-child ~ .file-list-item {
                margin-top: 20px;
              }
            }
          }
        }
      }
    }
  }
  .authorize-tips-content {
    @include flex-between;
    align-items: normal;
    position: absolute;
    z-index: 2000;
    top: 8%;
    left: calc(50% - 175px);
    width: 351px;
    height: 63px;
    padding: 20px;
    background: #ffffff;
    border: 1px solid #ff6900;
    border-radius: 10px;
    .icon {
      position: relative;
      width: 21px;
      height: 21px;
      flex-shrink: 0;
      margin-right: 15px;
      &::before {
        content: '';
        position: absolute;
        width: 21px;
        height: 21px;
        background: url('~assets/images/PromptSuccessful.png') no-repeat;
        background-size: 100%;
      }
    }
    .desc {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      .blue {
        color: #ff6900;
      }
    }
  }
  // 上传弹窗
  .upload {
    ::v-deep .el-dialog {
      width: 45%;
      min-height: 340px;
      background: #ffffff;
      border: 0px solid #818790;
      box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
      .el-dialog__header {
        height: 42px;
        background: #f4f6f7;
        padding: 0;
        display: flex;
        align-items: center;
        .el-dialog__title {
          margin-left: 10px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #393939;
        }
        .el-dialog__headerbtn {
          top: 15px;
        }
      }
      .el-dialog__body {
        padding: 27px 30px 0px;
        .content-text {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
        }
      }
    }
  }
  // 重命名弹窗样式
  .rename {
    ::v-deep .el-dialog {
      width: 428px;
      height: 253px;
      background: #ffffff;
      border: 0px solid #818790;
      box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .el-dialog__header {
        padding: 0;
        height: 42px;
        background: #f4f6f7;
        display: flex;
        align-items: center;
        .el-dialog__title {
          margin-left: 14px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #393939;
        }
        .el-dialog__headerbtn {
          top: 12px;
          right: 12px;
        }
      }
      .el-dialog__body {
        padding: 50px 30px 0;
        .content {
          display: flex;
          height: 50px;
          align-items: center;
          &-label {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            margin-right: 12px;
          }
          &-input {
            width: 290px;
            height: 50px;
            background: #ffffff;
            border: 1px solid #cecece;
            border-radius: 5px;
            padding-left: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #000000;
          }
        }
      }
      .el-dialog__footer {
        display: flex;
        justify-content: flex-end;
        padding: 50px 30px 0 0;
        .dialog-footer {
          display: flex;
          .footer-btn {
            width: 71px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #cecece;
            border-radius: 3px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
          }
          .sure {
            background: #4c8cff;
            color: #ffffff;
            margin-right: 12px;
          }
        }
      }
    }
  }
}
</style>
